export default __webpack_public_path__ + "static/media/AvenirNext-Heavy.e1a5c340.woff";